import { Button as e } from "../button/index.js";
import { EmptyState as t } from "../empty-state/index.js";
import { Icon as n } from "../icon/index.js";
import { Loading as r } from "../loading/index.js";
import { cn as i } from "../cn.js";
import { getStyles as a } from "./style.js";
import { Fragment as o, jsx as s } from "react/jsx-runtime";
// src/design/screen-state/index.tsx
function c({ loading: e = !1, fetched: t = !0, error: n, empty: r, filtered: i = !1 }) {
	return !t || e && r !== !1 ? "loading" : n ? "error" : r ? i ? "filtered-empty" : "empty" : "ready";
}
var l = (e) => {
	if (typeof e == "string") return e || void 0;
	if (e instanceof Error) return e.message || void 0;
}, u = ({ label: e = "Loading…", className: t }) => /* @__PURE__ */ s("div", {
	className: i(a().loading(), t),
	children: /* @__PURE__ */ s(r.Spinner, {
		size: "sm",
		text: e,
		textPosition: "right"
	})
}), d = ({ title: r = "Something went wrong", description: i, onRetry: a, className: o }) => /* @__PURE__ */ s("div", {
	role: "alert",
	className: o,
	children: /* @__PURE__ */ s(t, {
		title: r,
		description: i,
		icon: /* @__PURE__ */ s(n, {
			name: "CircleAlert",
			size: "lg",
			color: "inherit"
		}),
		config: { variant: "error" },
		children: a ? /* @__PURE__ */ s(e, {
			variant: "secondary",
			colorScheme: "default",
			onClick: () => a(),
			children: "Try again"
		}) : null
	})
}), f = ({ title: e = "Nothing here yet", description: r, icon: i, action: a, className: o }) => /* @__PURE__ */ s(t, {
	title: e,
	description: r,
	icon: i ?? /* @__PURE__ */ s(n, {
		name: "Inbox",
		size: "lg",
		color: "inherit"
	}),
	className: o,
	children: a
}), p = ({ title: r = "No results for these filters", description: i = "Try a wider search, or clear the filters.", onClear: a, className: o }) => /* @__PURE__ */ s(t, {
	title: r,
	description: i,
	icon: /* @__PURE__ */ s(n, {
		name: "SearchX",
		size: "lg",
		color: "inherit"
	}),
	className: o,
	children: a ? /* @__PURE__ */ s(e, {
		variant: "secondary",
		colorScheme: "default",
		onClick: () => a(),
		children: "Clear filters"
	}) : null
}), m = Object.assign(({ loading: e, fetched: t, error: n, empty: r, filtered: i, onRetry: a, onClearFilters: m, loadingContent: h, loadingLabel: g, errorTitle: _, emptyState: v, filteredEmptyState: y, className: b, children: x }) => {
	let S = c({
		loading: e,
		fetched: t,
		error: n,
		empty: r,
		filtered: i
	});
	return S === "loading" ? h ?? /* @__PURE__ */ s(u, {
		label: g,
		className: b
	}) : S === "error" ? /* @__PURE__ */ s(d, {
		title: _,
		description: l(n),
		onRetry: a,
		className: b
	}) : S === "empty" ? /* @__PURE__ */ s(f, {
		...v,
		className: b
	}) : S === "filtered-empty" ? /* @__PURE__ */ s(p, {
		...y,
		onClear: m,
		className: b
	}) : /* @__PURE__ */ s(o, { children: x });
}, {
	Loading: u,
	Error: d,
	Empty: f,
	FilteredEmpty: p
});
export { m as ScreenState, c as resolveScreenState };

//# sourceMappingURL=index.js.map